/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { Text } from 'hocs/localization'
import AddCardForm from 'apps/Profile/AddCardForm'
import BillingInfoForm from 'apps/Profile/BillingInfoForm'
import ShippingInfoForm from 'apps/Profile/ShippingInfoForm'
import BusinessDetailsForm from 'apps/Profile/BusinessDetailsForm'
import { correctedAllAddressesModal } from 'apps/Profile/CorrectedAddressModal'
import CollapsibleBlock from 'elements/CollapsibleBlock'
import Button from 'elements/Button/Button'
import * as styles from './SignUpForms.scss'
import SelectedPlan from 'apps/Profile/SelectedPlan'

const cx = classNames.bind(styles)

interface IProps {
  isSubmitting: boolean,
  name: string,
  t: Text,
  changeBillingCheckbox: () => void,
  changeBusinessCheckbox: () => void,
  submitForm: () => Promise<any>,
  isButtonDisabled: boolean,
  onConfirmCorrectedAddress: () => void
  isBillingCheckboxChecked: boolean,
  isBusinessCheckboxChecked: boolean,
  isPaymentDetailsOpened: boolean,
  plan: { name: string, id: string }
}

const SignUpForms: React.SFC<IProps> = ({
  isSubmitting,
  t,
  submitForm,
  isButtonDisabled,
  onConfirmCorrectedAddress,
  changeBillingCheckbox,
  changeBusinessCheckbox,
  isBillingCheckboxChecked,
  isBusinessCheckboxChecked,
  isPaymentDetailsOpened,
  plan,
}) => (
  <div className={styles.root}>
    <div className={cx('container', styles.container768)}>
      <div className={`row ${styles.topSpace50}`}>
        <div className={`col-md-12 text-center ${styles.topSpace30}`}>
          <div className={styles.selectedPlan}>
            <h2>{t('selectedPlanTitle')}</h2>
          </div>
        </div>
        {plan && <SelectedPlan plan={plan} />}
        <div className={`col-md-12 text-center ${styles.changePlanInfo}`}>{t('changePlanInfo')}</div>
        <div className={`col-md-12 text-center ${styles.topSpace30}`}>
          <CollapsibleBlock title={t('shippingTitle')} isOpen>
            <ShippingInfoForm isDisabled={isSubmitting} />
          </CollapsibleBlock>

          <CollapsibleBlock
            styleType='topSpace40'
            title={t('businessDetails')}
            onCheck={changeBusinessCheckbox}
            isChecked={isBusinessCheckboxChecked}
            checkboxTitle={t('areYouBusiness')}
            isCheckboxReverseMode
          >
            <BusinessDetailsForm isDisabled={isSubmitting} />
          </CollapsibleBlock>

          <CollapsibleBlock
            styleType='topSpace40'
            title={t('cardTitle')}
            isOpen={isPaymentDetailsOpened}
          >
            <AddCardForm isCardNumberAutoFocus={isPaymentDetailsOpened} isDisabled={isSubmitting} />
          </CollapsibleBlock>

          <CollapsibleBlock
            styleType='topSpace40'
            title={t('billingTitle')}
            onCheck={changeBillingCheckbox}
            isChecked={isBillingCheckboxChecked}
            checkboxTitle={t('sameAsShipping')}
          >
            <BillingInfoForm isDisabled={isSubmitting} isBillingCheckboxChecked={isBillingCheckboxChecked} />
          </CollapsibleBlock>
          <div className={styles.changePlanInfo}>{t('changePlanInfo')}</div>
          <div className={`row ${styles.topSpace50}`}>
            <div className='col-md-12 textcenter'>
              <div className={styles.NextButton}>
                <div className={styles.buttonWrap}>
                  <Button fluid disabled={isButtonDisabled || isSubmitting} onClick={submitForm}>
                    {isSubmitting ? t('submitting') : t('next')}
                    </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <correctedAllAddressesModal.Component onConfirm={onConfirmCorrectedAddress}/>
      </div>
    </div>
  </div>
)

export default SignUpForms
